/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const List: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M3 3.75v4.5h4.5v-4.5zm1.5 1.5H6v1.5H4.5zm4.5 0v1.5h11.25v-1.5zm-6 4.5v4.5h4.5v-4.5zm1.5 1.5H6v1.5H4.5zm4.5 0v1.5h11.25v-1.5zm-6 4.5v4.5h4.5v-4.5zm1.5 1.5H6v1.5H4.5zm4.5 0v1.5h11.25v-1.5z"/></svg>
);

export default List;
